/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Brand_WholesaleInputs */

const en_price_brand_wholesale = /** @type {(inputs: Price_Brand_WholesaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand wholesale`)
};

/**
* | output |
* | --- |
* | "Brand wholesale" |
*
* @param {Price_Brand_WholesaleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_brand_wholesale = /** @type {((inputs?: Price_Brand_WholesaleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Brand_WholesaleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_brand_wholesale(inputs)
});